/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import "DesignSystem/Fonts/Inter-500.css"
import Info from 'DesignSystem/Info/index'
import NoDataResult from 'DesignSystem/Images/NoDataResult/index'
import React from 'react'
import SupportLink from './SupportLink/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/No"
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="No.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-Fs': isBefore ? 0 : 1,'--ty-2-Fs': isBefore ? "8px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<NoDataResult
  viewPath={`${viewPath}/NoDataResult`}
 width={150}
 height="auto"
/>
<span
  data-testid="No.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
No data to report on
</span>
<Info
  viewPath={`${viewPath}/Info`}
 color="rgba(0,0,0,0.5)"
 marginTop={8}
 text="Try to refine your filters"
/>
<SupportLink
  viewPath={`${viewPath}/SupportLink`}
/>
</div>
{children}
</React.Fragment>)
}